module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Wi-fi-531284468c17b686bde7ddf6500cddb87143a16f1ab9f2e17673d4c303e04cc8.svg";